import { ceilPositiveMinutesToStep } from "../../../../../_shared/_logic/time-granularity"
import type { WorkOrderFormValue } from "../work-order-form-types"

export { DATE_ONLY_REGEX, normalizeDateOnly } from "../../../../_shared/_logic/timezones"

export const parseOptionalNumber = (value: string | number | null | undefined) => {
  if (value === null || value === undefined) return null

  const parsedInput = String(value).trim()

  if (!parsedInput) return null

  const parsed = Number(parsedInput)

  return Number.isFinite(parsed) ? parsed : null
}

export const parseOptionalDurationMinutes = (value: string | number | null | undefined) =>
  ceilPositiveMinutesToStep(value, null)

export const emptyWorkOrderForm = (orderNumber = ""): WorkOrderFormValue => ({
  property_id: "",
  property_unit_id: "",
  order_number: orderNumber,
  order_type_ids: [],
  custom_order_type: null,
  due_date: "",
  priority: "",
  estimated_duration_min: "",
  allowed_employee_ids: [],
})
